let dirty = false;

export const setFormDirty = (val: boolean) => {
  dirty = val;
};

export const isFormDirty = () => dirty;
